import React from "react";
import styled from "styled-components";
import { BiMedal } from "react-icons/bi";
import { HiOutlineTrophy } from "react-icons/hi2";
import { MdOutlineLocalActivity } from "react-icons/md";

const PRESETS = {
  sorteos: {
    icon: MdOutlineLocalActivity,
    title: "Sin sorteos activos",
    subtitle: "Nuevos sorteos llegan pronto. ¡Permanece atento!",
  },
  torneos: {
    icon: BiMedal,
    title: "Sin torneos activos",
    subtitle: "Muy pronto anunciaremos nuevos desafíos y premios.",
  },
  misteriosos: {
    icon: HiOutlineTrophy,
    title: "Sin misteriosos activos",
    subtitle: "Habrá sorpresas en camino. Vuelve a revisar en breve.",
  },
};

const Wrapper = styled.div`
  width: 100%;
  min-height: 220px;
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  gap: 0.5rem;
`;

const IconWrap = styled.div`
  display: grid;
  place-items: center;
  width: 96px;
  height: 96px;
  border-radius: 9999px;
  background: radial-gradient(closest-side, rgba(255, 215, 0, 0.1), transparent);
  filter: drop-shadow(0 0 12px rgba(255, 230, 0, 0.4));
`;

const Title = styled.span`
  font-size: 24px;
  font-weight: 900;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.25);
`;

const Subtitle = styled.span`
  font-size: 20px;
  opacity: 0.8;
  color: #fff;
`;

const Actions = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

const EmptyState = ({
  variant = "torneos",
  title,
  subtitle,
  icon,
  accentColor = "#ffdf5e",
  children,
}) => {
  const preset = PRESETS[variant] ?? PRESETS.torneos;
  const Icon = preset.icon;

  return (
    <Wrapper role="status" aria-live="polite">
      <IconWrap style={{ color: accentColor }}>{icon ?? <Icon size={72} />}</IconWrap>

      <Title>{title ?? preset.title}</Title>

      <Subtitle>{subtitle ?? preset.subtitle}</Subtitle>

      {children ? <Actions>{children}</Actions> : null}
    </Wrapper>
  );
};

export default EmptyState;
